<div class="progressbar">
	<kendo-progressbar
			[value]="value"
			[min]="0"
			[max]="100"
			[label]="labelSettings"
			[indeterminate]="indeterminate"
			[progressCssClass]="progressCssClass"
			[ngClass]="progressCssClass">
	</kendo-progressbar>
</div>
